import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=696bd7d8&scoped=true&"
import script from "./companyList.vue?vue&type=script&lang=js&"
export * from "./companyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696bd7d8",
  null
  
)

export default component.exports